<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Submitted Detail
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
              <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Submitted</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Submitted WebShell
            </div>
            <div class="mb7">
              <span class="float-right"> {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="pth_title">
                Address
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <div v-if="model && model.group_id" v-html="group_model.address"></div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="pth_title">
                Company
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.group_id" v-html="group_model.groupname"></div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">Status</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <!-- <b-badge :variant="model.is_done ? 'success' : 'secondary'">
                <div v-html="model.is_done ? 'Done' : 'Waiting'"></div>
              </b-badge> -->
              <b-badge :variant="model.is_done ? (model.is_alive ? (model.is_del ? 'danger' : 'success') : 'danger') : (model.is_del ? 'danger' : '-')">
                {{model.is_done ? (model.is_alive ? (model.is_del ? 'Deleted' : 'Approved') : 'Rejected') : (model.is_del ? 'Deleted' : '-')}}
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">Content Type</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-html="content_type"></div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">FileName</label>
            </b-col>
            <b-col class="col-xl-10 col-md-12  d-flex align-self-center">
              <div v-html="model.filename"></div>
            </b-col>
          </b-row>
          <b-row v-if="model.is_done && !model.is_webshell">
            <b-col md="12">
              <b-form-group>
                <label for="ph_title">Description(Reason)</label>
                <div v-html="model.description"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-12 col-md-12">
              <b-button class="float-right" size="sm" variant="warning" @click="decrypt" :disabled="decrypted">
                Force Decode base64
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
            <b-form-group>
              <hr>
              <label for="ph_descript">Content</label>
              <div v-html="content || model.content || 'None'" style="padding:15px;background:#f5f5f5;border:1px solid #ccc;border-radius:5px;"></div>
            </b-form-group>
            </b-col>
          </b-row>
          <b-form>
            <!-- <a id="download" :href="model.content" :download="model.filename" :v-show="true" style="text-decoration:none;!important;">
              <b-button size="sm" variant="primary" style="margin:0 2px;">
                Download
              </b-button>
            </a> -->
            <b-button size="sm" variant="danger" style="margin:0 2px;" @click="approve_confrm = true;" :disabled="model.is_del">
              Webshell Regist
            </b-button>
            <b-button size="sm" variant="success" @click="reject_confirm = true" :disabled="model.is_del">
              False positive
            </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Webshell Regist"  class="modal-danger" v-model="approve_confrm" @ok="approve" ok-variant="outline-danger" cancel-variant="outline-dark" header-bg-variant="danger">
      Would You Like to Regist?
    </b-modal>
    <b-modal title="False positive"  class="modal-danger" v-model="reject_confirm" @ok="reject" ok-variant="outline-danger" cancel-variant="outline-dark" header-bg-variant="danger">
      <b-form-group>
        <label for="ph_description">Description(Reason)</label>
        <b-form-textarea :rows="3" v-model="model.description" id="ph_description"></b-form-textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>